var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pui-error',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('i18n',{attrs:{"path":"platform.settings_error.title"}})]},proxy:true},{key:"subtitle",fn:function(){return [_c('span')]},proxy:true},{key:"action",fn:function(){return [_c('i18n',{attrs:{"path":"platform.settings_error.action"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }